/* eslint-disable */

/** select columns of table "argo.vw_material_class_udf_column" */
export enum ArgoVwMaterialClassUdfColumnSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  UdfColumnId = 'udf_column_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

